import { FormControl, FormGroup, Validators } from '@angular/forms';
import { type Vector2Like } from 'three';
import { AnatomicalSideEnum, BoneTypeEnum, BoneViewEnum, ImageOrientationEnum, ReferenceTypeEnum, setRequired } from '../core';


export class ImageCategorizationControl implements IImageCategorizationControl {
	boneType = new FormControl<BoneTypeEnum | null>(null, [Validators.required]);
	boneSide = new FormControl<AnatomicalSideEnum | null>(null, [Validators.required]);
	boneView = new FormControl<BoneViewEnum | null>(null, [Validators.required]);
	orientation = new FormControl<ImageOrientationEnum | null>(null, [Validators.required]);
	scaleFactor = new FormControl<number | null>(null, [Validators.required]);
	isRingCalibration = new FormControl<boolean | null>(null);
	ringCalibration = new FormControl<RingCalibrationResult | null>(null);
	edit = new FormControl<EditToolResult | null>(null);
}

export function setImgCategValidators(form: FormGroup<ImageCategorizationControl>): void {
	form.controls.isRingCalibration.valueChanges.subscribe(val => {
		setRequired(form.controls.ringCalibration, !!val);
	});
}

export const imgCategErrorMsgs: { [key in keyof ImageCategorizationForm]: { [y: string]: string[] } | null } = {
	boneType: { [`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_BONE_TYPE'] },
	boneSide: { [`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_BONE_SIDE'] },
	boneView: { [`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_BONE_VIEW'] },
	orientation: { [`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_IMAGE_ORIENTATION'] },
	scaleFactor: null,
	isRingCalibration: null,
	ringCalibration: null,
	edit: null
}

export interface IImageCategorizationControl {
	boneType: FormControl<BoneTypeEnum | null>;
	boneSide: FormControl<AnatomicalSideEnum | null>;
	boneView: FormControl<BoneViewEnum | null>;
	orientation: FormControl<ImageOrientationEnum | null>;
	scaleFactor: FormControl<number | null>;
	isRingCalibration: FormControl<boolean | null>;
	ringCalibration: FormControl<RingCalibrationResult | null>;
	edit: FormControl<EditToolResult | null>;
}

export interface ImageCategorizationForm {
	boneType: BoneTypeEnum | null;
	boneSide: AnatomicalSideEnum | null;
	boneView: BoneViewEnum | null;
	orientation: ImageOrientationEnum | null;
	scaleFactor: number | null;
	isRingCalibration: boolean;
	ringCalibration: RingCalibrationResult | null;
	edit: EditToolResult | null;
}

export interface RingCalibrationResult {
	referenceType: ReferenceTypeEnum | null;
	ellipsePoints: Vector2Like[] | null;
	proxRingId: number | null;
	distalRingId: number | null;
	ringMatrix: number[] | null;
	angle: number | null;
	frontal: number | null;
	axial: number | null;
}

export interface EditToolResult {
	brightness: number | null;
	contrast: number | null;
	rotation: number | null;
}
